import React from "react"
import styled from "styled-components"

import { media } from "../../../components/mediaStylesNew"

const QuestionText = styled.div`
  font-family: Recife Text, serif;
  ${media.desktop`
    font-size: 34px;
    padding: 10px 0px;
    line-height: 36px;
  `};
  font-size: 64px;
  line-height: 70px;
  padding: 20px 0;
  font-weight: 600;
`

const QuestionDescription = styled.div`
  font-family: GT America, sans-serif;
  font-size: 20px;
  padding: 10px 0;
  ${media.desktop`
    font-size: 16px;
    line-height: 41px;
  `};
`

const QuestionWrapper = styled.div`
  padding-bottom: 20px;
  ${media.tablet`
    margin-bottom: 10px;
    padding-bottom: 10px;
    max-width: 600px;
  `}
`

const Separator = styled.div`
  height: 25px;
`

export default ({ text = "", description = "", focus = false }) => {
  return text || description ? (
    <QuestionWrapper>
      <QuestionText focus={focus}>{text}</QuestionText>
      {description && <QuestionDescription>{description}</QuestionDescription>}
    </QuestionWrapper>
  ) : (
    <Separator />
  )
}
